// @ts-strict-ignore
import React from 'react'
import classNames from 'classnames'
import Image from '../../imgix-img'
import { removeWhitespaceAndSpecialChars } from '@h/commons'

export interface IProviderLogo {
  id: string
  name: string
  images: {
    money: string
    uswitch: string
  }
}

interface IProviderLogoPlatinum {
  name: string
  provider: IProviderLogo[]
  orderOverride: string[]
}

const overrideProviderOrder = (providers: IProviderLogo[], overrideOrder: string[]) => {
  const overridePriority = [...overrideOrder].reverse()
  const reOrderedProviders = [...providers]

  overridePriority.forEach((override) => {
    const indexOfOverride = reOrderedProviders.findIndex((provider) => {
      return provider.name.toLowerCase() === override.toLowerCase()
    })

    if (indexOfOverride !== -1) {
      reOrderedProviders.unshift(reOrderedProviders.splice(indexOfOverride, 1)[0])
    }
  })

  return reOrderedProviders
}

const maxProvidersToDisplay = 10

const ProviderLogoPlatinum: React.FC<IProviderLogoPlatinum> = ({
  provider,
  orderOverride,
  name,
  variant,
}) => {
  const orderedProviders = (
    orderOverride ? overrideProviderOrder(provider, orderOverride) : provider
  ).slice(0, maxProvidersToDisplay)

  return (
    <div id={removeWhitespaceAndSpecialChars(name)}>
      <div className='ProviderLogoPlatinum'>
        <div className='ProviderLogoPlatinum__photobanner'>
          {orderedProviders.map(({ id, name, images }) => {
            return (
              <Image
                key={id}
                className={classNames('ProviderLogoPlatinum__image', {
                  'ProviderLogoPlatinum__image--ppc': variant === 'ppc',
                })}
                src={images.money}
                width={variant === 'cardFinderProviders' ? 84 : variant === 'ppc' ? 150 : 100}
                alt={name}
                critical={false}
              />
            )
          })}
          {orderedProviders.map(({ id, name, images }) => {
            return (
              <Image
                key={id}
                className={classNames(
                  'ProviderLogoPlatinum__image ProviderLogoPlatinum__image--desktop',
                  {
                    'ProviderLogoPlatinum__image--ppc': variant === 'ppc',
                  },
                )}
                src={images.money}
                width={variant === 'cardFinderProviders' ? 84 : variant === 'ppc' ? 150 : 100}
                alt={name}
                critical={variant === 'cardFinderProviders' || variant === 'ppc'}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default ProviderLogoPlatinum
